import styled from '@emotion/styled'

export const Metric2 = styled.p(({ theme }) => ({
  fontFamily: theme.typography.family.heading,
  fontSize: '2rem',
  lineHeight: 1,
  fontWeight: 500,
  margin: 0,
  padding: 0,
}))
